import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import MUIButton from "@material-ui/core/Button";
import React, { FC } from "react";

import classes from "./CampaignTemplateSummarySlide.module.scss";
import successIcon from "../../assets/icons/SuccessIcon.svg";

type SuccessDialogProps = {
  isOpen: boolean;
  handleClose: () => void;
  title: string;
};

const SuccessDialog: FC<SuccessDialogProps> = ({ isOpen, handleClose, title }) => {
  return (
    <Dialog open={isOpen} onClose={handleClose} aria-labelledby="dialog-title" aria-describedby="dialog-description">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <img className={classes.successIcon} src={successIcon} alt="Success icon" />
      </DialogContent>
      <DialogActions>
        <MUIButton onClick={handleClose} color="primary">
          Finish
        </MUIButton>
      </DialogActions>
    </Dialog>
  );
};

export default SuccessDialog;
